import { Box, Tooltip } from '@chakra-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

interface HeaderMenuItemProps {
  to?: string;
  icon: React.ReactNode;
  tooltip: string;
  isActive?: boolean;
  onClick?: () => void;
  asLink?: boolean;
  testId?: string;
}

export const HeaderMenuItem: React.FC<HeaderMenuItemProps> = ({
  to,
  icon,
  tooltip,
  isActive = false,
  onClick,
  asLink = true,
  testId,
}) => {
  const commonProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    paddingX: 4,
    paddingY: 1,
    marginLeft: 1,
    marginRight: testId === 'NotificationMenuItem' ? 4 : 1,
    transition: 'background-color 0.2s',
    bg: isActive ? 'whiteAlpha.300' : 'transparent',
    _hover: { bg: 'whiteAlpha.300' },
    _active: { bg: 'whiteAlpha.300' },
    cursor: onClick ? 'pointer' : 'default',
    ...(onClick && { onClick }),
    ...(testId && { 'data-testid': testId }),
  };

  const Element = asLink && to ? Link : 'div';

  return (
    <Tooltip label={tooltip}>
      <Box as={Element} {...(asLink && to ? { to } : {})} {...commonProps}>
        {icon}
      </Box>
    </Tooltip>
  );
};
